"use client";
import { useState, useCallback } from "react";
import { FindYourPathLayoutVariant } from "@/monarch/rules/findYourPath/types";

/**
 * Hook to manage the layout variant for the first view only.
 * After user interaction (entry CTA click or first question answer),
 * the variant switches to "default" for the rest of the quiz.
 */
export const useFirstViewVariant = (
  layoutVariant: FindYourPathLayoutVariant = "default",
) => {
  const [hasInteracted, setHasInteracted] = useState(false);

  // Return the configured variant for first view, then default after interaction
  const currentVariant: FindYourPathLayoutVariant = hasInteracted
    ? "default"
    : layoutVariant;

  // Mark that user has interacted (should be called on entry CTA click or first question answer)
  const markInteracted = useCallback(() => {
    setHasInteracted(true);
  }, []);

  // Reset interaction state (should be called when user starts over)
  const resetInteraction = useCallback(() => {
    setHasInteracted(false);
  }, []);

  return {
    currentVariant,
    hasInteracted,
    markInteracted,
    resetInteraction,
  };
};
